export const experienceData = [
    // {
    //     id: 11,
    //     year:'2024',
    //     yearRange: '2024-Present',
    //     name: 'Full Stack Engineer',
    //     institute: 'Self Employed',
    //     description: 'Collaborate with clients to design, develop, and deploy web applications. Create responsive front-end interfaces and robust back-end solutions. Proficient in HTML, CSS, JavaScript, Node.js, Express.js, and integrating APIs. Successfully completed multiple projects on time and within budget, ensuring client satisfaction.'
    // },
    {
        id: 9,
        year:'2025',
        yearRange: '2025-Present',
        name: 'Sales Specialist (SMB Advocate)',
        institute: 'Verizon',
        description: 'Manage a portfolio of consumer and business accounts, identifying and converting new sales opportunities while diagnosing and resolving technical, billing, and account issues. Work across account management, tech support, billing, and loyalty teams to fully resolve customer needs, and act as the go-to resource for business accounts when the account manager is out.'
    },
    {
        id: 8,
        year:'2024',
        yearRange: '2023-2025',
        name: 'Software Engineer',
        institute: 'Reflectica AI',
        description: 'Built and maintained customer-facing mobile features using React Native, TypeScript, Firebase, and Node.js at an early-stage AI startup. Worked directly with the founders on product development, testing, and troubleshooting based on user feedback, and built internal tools that cut down manual work for the team.'
    },
    {
        id: 7,
        year:'2023',
        yearRange: '2023-2024',
        name: 'Coding Instructor',
        institute: 'CodeRev Kids',
        description: 'Taught programming fundamentals and video game development to kids using tools like Pencil Code and Scratch, plus hands-on Arduino projects with Snap Circuits. Learned a lot about breaking big concepts down into small, digestible pieces.'
    },
    {
        id: 6,
        year:'2023',
        yearRange: '2023-2024',
        name: 'Learning Assistant',
        institute: 'edX',
        description: 'Supported students working through a range of programming languages and concepts, adapting my approach to how each person learned best. Built real trust in a virtual setting, which is harder than it sounds.'
    },
    {
        id: 5,
        year:'2023',
        yearRange: '2023-2024',
        name: 'Founder and Administrator',
        institute: 'Programming Accountability Group',
        description: 'Started and ran a group to help fellow developers stay consistent with their coding goals, organizing regular check-ins and keeping people motivated. Good practical lesson in leading without any formal authority.'
    },
    {
        id: 4,
        year:'2023',
        yearRange: '2023-2023',
        name: 'Hackathon',
        institute: 'Bay Area Hacks 23',
        description: 'Built a MERN app with GraphQL and Material UI in a weekend, handling both frontend and backend with React, Express, Node, and MongoDB. Pitched it to judges with zero sleep and somehow made it coherent.'
    },
    {
        id: 3,
        year:'2022',
        yearRange: '2022-2023',
        name: 'Leasing Consultant',
        institute: 'Asset Living',
        description: 'Managed the move-in/move-out process for a majority of a 750+ bed property while handling customer service and resolving resident issues. Grew social media engagement by 22.7% and helped push the property\'s Google rating from 1.2 to 3.1 stars.'
    },
    {
        id: 2,
        year:'2022',
        yearRange: '2022-2022',
        name: 'Fullstack Coding Bootcamp',
        institute: 'University of Washington',
        description: 'Completed a 24-week full-stack coding bootcamp covering HTML, CSS, JavaScript, Git, and Agile methodology, along with server-side APIs, OOP, SQL, and React. This is where the tech career actually started.'
    },
    {
        id: 1,
        year:'2020',
        yearRange: '2016-2020',
        name: 'Bachelor\'s Degree',
        institute: 'University of Washington',
        description: 'Graduated with a BA in Anthropology. Spent four years studying how people think and behave, which turned out to be surprisingly good training for understanding users, not just data.'
    }
]